import * as yup from 'yup'

export const reviewPaymentValidator = yup.object({
  reviewNotes: yup.string().test('not-blank', 'Add a note explaining the decision', (value) => {
    return (value ?? '').trim().length > 0
  }),
})
